import React from 'react';
import {customers, modals, permissionGroups} from "../../../ducks";
import duckify, {filterDuck, singleDuck} from "../../../utils/duckify";
import PageHeader from "../../PageHeader";
import ContactList from "../../ContactList/ContactList";
import FALabel from "../../shared/FALabel";
import LinkButton from "../../LinkButton/LinkButton";
import ModalRoot from "../../ModalRoot";
import EditGroupModal from "./EditGroupModal";
import './styles/PermissionGroups.scss';
import flags from "../../../../../config/admin_flags.json";
import {compose} from "redux";
import withFiltering from "../../../hocs/withFiltering";
import withPagination from "../../../hocs/withPagination";
import withSorting from "../../../hocs/withSorting";
import Filters from "../../Filters/Filters";
import Pagination from "react-ultimate-pagination-bootstrap-4";
import FA from "../../../utils/FA";
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan'
import { faCheckCircle as faCheckCircleSolid } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import {defaultColumn} from "../../ContactList/ColumnDefinitions";

const GroupListPage = ({
  groups,
  currentCustomer,
  onEditGroup,
  onDeleteGroup,
  showAudits,
  filters,
  onSort,
  page,
  setFilters,
  setPage,
  sort
}) => {
  const filteredFlags = currentCustomer.review_enabled ? flags : flags.filter(flag => flag.canonical_name !== 'reader_permitted');
  const columns = [
    defaultColumn({
      header: 'Group Name',
      sortName: 'name',
      value: 'name',
      columnClassNames: 'permission-group-name-cell'
    }),
    currentCustomer.super_id && defaultColumn({
      header: 'Source',
      sortName: 'customer_id',
      value: 'source'
    }),
    ...filteredFlags.map(flag => defaultColumn(
      {
        header: flag.name,
        sortName: flag.canonical_name,
        value: group => <td className='permission-icon-cell'><FA className={group[flag.canonical_name] ? 'yes-permission' : 'no-permission'} icon={group[flag.canonical_name] ? faCheckCircleSolid : faBan} /></td>
      }
    )),
    defaultColumn({
      header: '',
      value: group => !!group.source ? <td /> : (
        <td>
          <LinkButton onClick={() => onEditGroup(group, filteredFlags)} content="Edit" />{' | '}
          <LinkButton onClick={() => showAudits(group.id)} content="View Changes" />{' | '}
          <LinkButton onClick={() => onDeleteGroup(group)} content="Delete" />
        </td>
      )
    })
  ].filter(val => !!val);

  const totalPages = groups ? Math.ceil(groups.total / groups.perPage) : 0;

  return <React.Fragment>
    <PageHeader header="Admin Permission Groups" />

    <Filters
      fields={[{solr_prompt: 'name', display_name: 'Group Name', filter_type: 'TextFilter'}]}
      selected={filters}
      submitFilters={setFilters}
      itemsName='Permission Groups'
    />

    <div className='permission-group-list-add'>
      <LinkButton
        className="add-item-button"
        content={<FALabel icon="plus-circle" iconFirst label=" Add a new group" />}
        onClick={() => onEditGroup(undefined, filteredFlags)}
      />
    </div>

    {totalPages > 1 && (
      <div className='contact-list-react-pagination'>
        <div className='pagination pagination-right'>
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            hideFirstAndLastPageLinks
            onChange={setPage}
          />
        </div>
      </div>
    )}

    <ContactList
      className="table-hover permission-group-table"
      columns={columns}
      contacts={groups}
      emptyMessage="No groups"
      onSort={onSort}
      sort={sort}
    />

    <ModalRoot modals={{ EditGroupModal }} />
  </React.Fragment>;
};

const mapDucksToProps = ({filters, sort, page, perPage}) => ({
  groups: filterDuck(permissionGroups, {filters, sort, page: page || 1, per_page: perPage}),
  currentCustomer: singleDuck(customers, 'current')
});

const mapDispatchToProps = (dispatch) => ({
  onEditGroup: (group, filteredFlags) => dispatch(modals.actions.show('EditGroupModal', { permissionGroup: group, flags: filteredFlags })),
  onDeleteGroup: group => dispatch(modals.actions.show('VerificationModal', {
    confirmButtonType: 'primary',
    message: (<>
      <p>You have chosen to delete {group.name}.</p>
      <p>Permission Groups can only be deleted if they are not linked to any admins.</p>
    </>),
    confirmText: 'Delete',
    onConfirm: () => dispatch(permissionGroups.actions.remove(group))
      .then(() => dispatch(permissionGroups.actions.markDirty()))
      .catch(response => {
        Utility.displayFlashMessages({ error: `Failed to delete group${response.error ? `: ${response.error}` : ''}` });
      }),
    title: 'Delete Group',
    onClose: () => dispatch(modals.actions.hide()),
  })),
  showAudits: (id, resource = 'permission_groups') => dispatch(modals.actions.show('AuditViewer', {
    id,
    resource
  }))
});

export default compose(
  withFiltering,
  withPagination,
  withSorting({column: 'name', order: 'asc'}),
  duckify(mapDucksToProps, () => ({}), mapDispatchToProps)
)(GroupListPage);
